.topicName {
    color: var(--mantine-color-gray-7);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.4px;
    line-height: 1rem;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: uppercase;
    margin: 0;
}

.fillingData {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
}

.fillingTitle {
    color: var(--mantine-color-gray-7);
    font-size: 1rem;
    font-weight: 700;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.comboboxContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.combobox {
    flex: 0 0 calc(50% - 0.25rem);
    overflow: hidden;
}
